export default defineNuxtRouteMiddleware(({ query }) => {
  const { isAutoPromoCodeEnabled } = useAppConfig().pages.cart.coupon
  if (isClient() && isAutoPromoCodeEnabled) {
    if (query.autoPromoCode && typeof query.autoPromoCode === 'string')
      useSessionStorage('autoPromoCode', '').value = query.autoPromoCode
  }
})
